<template>
  <v-row class="fill-height py-0">
    <template v-if="isGroupTab" >
      <!-- Custom Layout for 'groups' route -->
      <v-col cols="12">
        <v-row class="toolbar-row px-1  align-center">
          <v-col class="pt-0 pl-6 pb-4  toolbar-sorter" cols="12" sm="12" md="auto">
            <slot name="left"/>
          </v-col>
          <v-col class="pt-0 pb-4  toolbar-search" cols="12" sm="12" md="">
            <slot name="main"/>
          </v-col>
          <v-col class="pt-0 pb-4 pr-3 toolbar-export" cols="12" sm="12" md="auto">
            <slot name="right"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="scrollbar-width: none;" class="py-0 scroll-right-lg-y scroll-right-md-y" cols="12">
            <slot name="feed-group"></slot>
          </v-col>
        </v-row>
      </v-col>
    </template>
    <template v-else-if="isProfileTab">
      <v-row><slot name="top"></slot></v-row>
      <v-row><slot name="bottom"></slot></v-row>
    </template>
    <template v-else>
      <!-- Default Layout -->
      <v-col class="py-0 pl-0 pr-4 pr-lg-0 d-none d-lg-flex tree-menu-width" cols="12" lg="2">
        <slot name="left"/>
      </v-col>
      <v-col class="max-width-content" :class="{'pa-0': this.$route.path === '/administrators/inviteUser' || this.$route.path === '/administrators'}" cols="12" lg="12">
        <v-row class="justify-start mx-0 px-0 d-flex flex-column">
          <slot name="top"></slot>
        </v-row>
        <v-row v-if="this.$route.name === 'performance' || this.$route.name === 'performance_device'" class="toolbar-row px-2 align-center">
          <v-col class="pt-0 pb-4 toolbar-search" cols="12" sm="12" md="">
            <slot name="top-search-perform"></slot>
          </v-col>
          <v-col class="pt-0 pb-4 toolbar-export" cols="12" sm="12" md="auto">
            <slot name="top-btn-perform"></slot>
          </v-col>
        </v-row>
        <v-row v-if="this.$route.name === 'performance' || this.$route.name === 'performance_device'">
          <v-col cols="12" lg="3" xl="3"></v-col>
          <v-col cols="12" lg="9" xl="9">
            <slot name="performance-headings"></slot>
          </v-col>
        </v-row>
        <v-row v-if="this.$route.name === 'Administrators' || this.$route.name === 'accounts_action'" class="toolbar-row px-3 align-center">
          <v-col class="pt-0 pb-0 toolbar-search" cols="12" sm="12" md="">
            <slot name="top-search-accounts"></slot>
            <router-view :key="$route.params.tab" />
          </v-col>
          <v-col class="pt-0 pb-0 toolbar-export" cols="12" sm="12" md="auto">
            <slot name="top-left-btn"></slot>
          </v-col>
        </v-row>
        <v-row class="toolbar-row justify-end px-2 pl-3 align-center">
          <v-col class="pt-0 pb-4 pl-4 pr-2 toolbar-sorter" v-if="this.view === 'grid'" cols="12" sm="12" md="auto">
            <slot name="left-top"/>
          </v-col>
          <v-col class="pt-0 pb-4 pr-2 pl-1 toolbar-search" cols="12" sm="12" md="">
            <slot name="right-top"/>
          </v-col>
          <v-col class="pt-0 pb-4 pr-2 pl-1 toolbar-export" cols="12" sm="12" md="auto">
            <slot name="right-top-btn"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-2 pt-0 scroll-right-lg-y scroll-right-md-y">
            <slot name="right"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-2 pt-0 scroll-right-lg-y scroll-right-md-y">
            <slot name="main"/>
          </v-col>
        </v-row>
      </v-col>
      <v-row>
        <v-col class="py-0 pl-0 pr-4 pr-lg-0 d-none d-lg-flex botom-menu-width" cols="12" lg="2">
          <slot name="bottom"/>
        </v-col>
      </v-row>
    </template>
  </v-row>
</template>

<script>
export default {
  name: 'TemplateFeed',
  computed: {
    view() {
      return this.$store.state.view
    },
    isGroupTab(){
      return ['groups', 'group', 'group_action'].includes(this.routeName)
    },
    isProfileTab(){
      return ['ooperators', 'operator-groups'].includes(this.routeName)
    },
    isRunnersTab(){
      return ['Runners', 'RunnerDetails'].includes(this.routeName)
    },
   routeName() {
     return this.$route.name;
   },
  }
};
</script>

<style>
.fill-height {
  scrollbar-width: none; /* Dodano globalno za Firefox */
  -ms-overflow-style: none; /* Dodano za Internet Explorer/Edge */
}
/* Za WebKit browsere (Chrome, Safari, itd.) */
.fill-height::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  display: none !important;
}
.tree-menu-width {
  min-width: 274px;
  max-width: 274px;
  max-height: calc(100vh - 124px);
}
/* Bez ovoga siroka tablica siri flex roditelja i izaziva horizontalni overflow. */
.max-width-content,
.scroll-right-lg-y,
.scroll-right-md-y {
  min-width: 0;
}

.botom-menu-width {
  min-width: 274px;
  max-width: 274px;
}

@media only screen and (min-width: 1264px) {
  .scroll-right-lg-y {
    max-height: calc(100vh - 184px);
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .scroll-left-lg-y {
    max-height: calc(100vh - 240px);
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .max-width-content {
    max-width: calc(100% - 274px);
    min-width: 0;
  }
}


@media only screen and (max-width: 1264px) and (min-width: 960px) {
  .scroll-right-md-y {
    max-height: calc(100vh - 184px);
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .scroll-left-md-y {
    max-height: calc(100vh - 240px);
    overflow-x: hidden;
    overflow-y: scroll;
  }
}

/* Toolbar row: no-wrap on md+ so items stay in one line */
@media only screen and (min-width: 960px) {
  .toolbar-row {
    flex-wrap: nowrap !important;
  }
  .toolbar-sorter {
    flex: 0 0 25% !important;
    max-width: 25% !important;
  }
  .toolbar-search {
    flex: 1 1 0 !important;
    min-width: 0 !important;
  }
  .toolbar-export {
    flex: 0 0 120px !important;
    max-width: 120px !important;
    padding-left: 0 !important;
  }
  /* Override for specific case */
  .v-row.toolbar-row .v-col.toolbar-export {
    padding-left: 0 !important;
  }
}

/* Mobile: wrap and full width */
@media only screen and (max-width: 959px) {
  .toolbar-row {
    flex-wrap: wrap !important;
  }
  .toolbar-sorter,
  .toolbar-search,
  .toolbar-export {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .toolbar-export {
    padding-left: 12px !important;
  }
}
</style>
